<template>
    <div>
		<b-pagination v-model="configTable.currentPage" :per-page="configTable.perPage" :total-rows="configTable.rows" size="sm" class="pl-3" style="float:right" v-if="configTable.perPage != 'Todos'">
		</b-pagination>
        <b-form-select v-model="configTable.perPage" :options="[100, 500, 1000, 'Todos']" size="sm" class="mb-3 col-2" style="float:right"></b-form-select>
    </div>
</template>

<script>
export default {
    props: ['configTable']
}
</script>
